import AudiofileTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudiofileTranslationResponse";

export default class MusicAudioTranslationViewModel {
    langCode: string = '';
    name: string = '';
    index: number = 0;
    constructor(obj?: Partial<MusicAudioTranslationViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): AudiofileTranslationResponse {
        return new AudiofileTranslationResponse({
            LangCode: this.langCode,
            Name: this.name,
            Index: this.index
        });
    }
}